import { render, staticRenderFns } from "./LostReasonList.vue?vue&type=template&id=7216149c&"
import script from "./LostReasonList.vue?vue&type=script&lang=js&"
export * from "./LostReasonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports